module.exports = __webpack_public_path__ + "img/proyectos5.8253b8e5.png";